import Banner from "../banner";
import '../../styles/servicios.scss';
import ventilacion from '../../assets/ventilacion.jpg';
import Button from "../button";
import { HashLink as Link } from 'react-router-hash-link';
import SimpleHeader from "../simpleHeader";
import ScrollAnimation from "react-animate-on-scroll";

function Ventilacion(){
  return(
    <div>
      <SimpleHeader />
    <div className='servicio-info'>
    <ScrollAnimation animateIn="fadeInLeft" animateOnce={true}>
      <Banner text='Diseño. Construcción. Montaje.'/>
      <h2>Ventilación Industrial</h2>
    </ScrollAnimation>
    <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={3}>
      <div className='servicios-detalles'>
        <div className='imagen'>
          <img src={ventilacion} alt=""/>
        </div>
        <div className='detalles'>
          <div className='detalles-box'>
            <h3>Nuestro servicio incluye:</h3>
            <ul>
              <li>- Ingeniería, proyecto y montajes.</li>
              <li>- Climatización del aire.</li>
              <li>- Provisión de equipos.</li>
              <li>- Diseño y fabricación.</li>
              <li>- Reparación y mantenimiento de equipos.</li>
              <li>- Cabinas de pintura.</li>
              <li>- Aislaciones térmicas, cañerías y accesorios.</li>
              <li>- Instalación de extractores de pared y techo.</li>
            </ul>
          </div>
          <Link smooth to='/home/#contacto' >
            <Button text='CONTACTANOS' />
          </Link>
        </div>
      </div>
      </ScrollAnimation>
    </div>
    </div>
    );
}

export default Ventilacion;